import { useAccountAPI } from '../../apis/account-api';
import { useStorage } from '../../hooks/use-storage';

function useUserManager() {
  const { user } = useStorage();
  const { checkCurrentAccountFromRemote } = useAccountAPI();

  async function checkCurrentUser(clearUser = () => {}) {
    if (user != null) {
      try {
        await checkCurrentAccountFromRemote();
      } catch (error) {
        if (error.response.status === 401) {
          clearUser();

          return Promise.resolve({
            data: null,
          });
        }

        throw error;
      }
    }

    return Promise.resolve({
      data: user,
    });
  }

  return { checkCurrentUser };
}

export { useUserManager };
